import React from 'react';
import {useDroppable} from '@dnd-kit/core';
import styled from 'styled-components';

const Container = styled.div`
  border-style: dashed;
  border-radius: 10px;
  width: 128px;
  height: 128px;
`;

function Droppable(props) {
  const {isOver, setNodeRef} = useDroppable({
    id: 'droppable',
  });
  
  return (
    <Container ref={setNodeRef}>
      {props.children}
    </Container>
  );
}

export default Droppable;